import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

export default function CommandComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);

    return type.create(CommandComponent, {
        addCommand(baseUrl: $TSFixMe, params: $TSFixMe) {
            return createRequest(apiComponent.request, baseUrl)('/addCommand', params);
        },
    });
}
